<template>
  <section id="services" ref="targetElement" class="py-10 sm:py-14 lg:py-16 bg-white dark:bg-gray-900">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div
        class="mb-8 transition-all duration-700 ease-out"
        :class="isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'"
      >
        <p class="text-sm font-bold uppercase tracking-wide text-blue-600 dark:text-blue-400 mb-2">
          Leistungen
        </p>
        <h2 class="text-3xl sm:text-4xl font-bold text-gray-900 dark:text-gray-100">
          Was ich für Sie umsetze
        </h2>
      </div>

      <div class="grid grid-cols-1 md:grid-cols-3 gap-4 sm:gap-5">
        <article
          v-for="(service, index) in services"
          :key="service.title"
          class="group bg-gray-50/90 dark:bg-gray-800/70 p-5 sm:p-6 rounded-2xl border border-gray-200 dark:border-gray-700 transition-all duration-300 hover:-translate-y-1 hover:border-blue-300 dark:hover:border-blue-700 hover:shadow-lg hover:shadow-blue-100/60 dark:hover:shadow-black/20"
        >
          <div class="flex items-center justify-between mb-5">
            <div class="w-12 h-12 rounded-xl border border-blue-100 dark:border-blue-800 bg-blue-50 dark:bg-blue-950/40 flex items-center justify-center text-blue-600 dark:text-blue-300 shadow-sm">
              <component :is="service.icon" class="h-6 w-6" aria-hidden="true" />
            </div>
            <div class="text-sm font-black text-blue-500 dark:text-blue-400">
              {{ String(index + 1).padStart(2, '0') }}
            </div>
          </div>

          <h3 class="text-xl sm:text-2xl font-bold text-gray-900 dark:text-gray-100 mb-2">
            {{ service.title }}
          </h3>
          <p class="text-sm sm:text-base text-gray-600 dark:text-gray-300 leading-relaxed mb-5">
            {{ service.description }}
          </p>

          <router-link
            to="/contact"
            class="inline-flex items-center text-sm sm:text-base font-bold text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300"
          >
            Anfragen
            <ArrowRightIcon class="ml-2 w-5 h-5 transition-transform group-hover:translate-x-1" aria-hidden="true" />
          </router-link>
        </article>
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
import {
  ArrowRightIcon,
  BuildingStorefrontIcon,
  CursorArrowRaysIcon,
  WrenchScrewdriverIcon
} from '@heroicons/vue/24/outline'
import { useScrollAnimation } from '../../composables/useScrollAnimation'

const services = [
  {
    title: 'Neue Website',
    description: 'Ein professioneller Auftritt, der Ihr Angebot schnell verständlich macht.',
    icon: BuildingStorefrontIcon
  },
  {
    title: 'Website überarbeiten',
    description: 'Wenn Ihre aktuelle Seite moderner und klarer verkaufen soll.',
    icon: CursorArrowRaysIcon
  },
  {
    title: 'Funktionen ergänzen',
    description: 'Formulare, Buchungen oder Tools, die Ihnen Arbeit abnehmen.',
    icon: WrenchScrewdriverIcon
  }
]

const { isVisible, targetElement } = useScrollAnimation({
  threshold: 0.1,
  rootMargin: '0px 0px -50px 0px'
})
</script>
